export const PagFilter = {
  "firstReg": 0,
  "currentPage": 1,
  "numRegPag": 15,
  "totalReg": -1,
  "sortingBy": []
}